<template>
    <v-dialog v-model="dialogProp" width="500">
        <v-card>
            <v-toolbar flat>
                <v-spacer />
                <v-btn icon @click="dialogProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title>
                <h4 style="word-break: break-word;">
                    Out-Patient Care:
                </h4>
            </v-card-title>
            <v-divider />

            <v-card-text>
                <ul v-for="(desc, i) in descs" :key="i">
                    <li>{{ desc }}</li>
                </ul>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['showOutpatient'],

    data: () => ({
        mdiClose,
        descs: [
            'Consultations during doctors’ clinic hours (excluding 	prescribed medicines).',
            'Referral to an HMI affiliated specialist by the HMI PIC 	(during doctors’ clinic hours).',
            'Treatment of minor emergency illnesses or injuries (not 	requiring confinement).',
            'Minor Surgical Procedures  (not requiring confinement).',
            'Laboratory examinations and all other diagnostic 	procedures as determined and prescribed by an HMI 	affiliated physician, and done at HMICare Clinics or HMI-	Affiliated Laboratory designated by the HMI Hospital 	Operations Department (except pre-existing conditions 	during the first year of membership).'
        ]
    }),
    computed: {
        dialogProp: {
            get() {
                return this.showOutpatient
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>

<style scoped>
ul li {
  font-size: 13px;
  padding-top: 10px;
  color: black;
  text-align: justify;
}
</style>
